
import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model";
import { UsersModel } from "./user-data-model";

export class UsersGridModel extends UsersModel { }

export class UsersListingModel extends GridModel<UsersGridModel> { }

export class UsersGridParams extends GridPostParams {
    pageNumber: 1;
    pageSize: 10;
    search_text: '';
    direction: '';
    column: ''
}

export { UsersModel };